'use client';

import React from 'react';
import clx from 'classnames';

import styles from './Reel.module.css';

interface Props {
    as?: 'div' | 'ul';
    children: React.ReactNode;
    spacing?: 'gap-100';
    className?: string;
    hybridReel?: boolean;
}

const Reel = ({ as: Tag = 'div', children, className, hybridReel = false, spacing = 'gap-100' }: Props) => {
    const classNames = clx(
        styles.reel,
        hybridReel ? styles.hybridReel : '',
        spacing,
        className,
    )

    return <Tag className={classNames}>{children}</Tag>;
}

export default Reel;
